/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Startseite',
	homePageTabsLabel: 'Inhalt der Startseite',
	myContent: 'Eigener Inhalt',
	teamContent: 'Teaminhalt',
	folder: 'Ordner',
	files: 'Dateien',
	actionMenu: 'Aktionsmenü',
	myFolder: 'Eigene Ordner',

	emptyFolderNoContent: 'Kein Inhalt',

	//EmptyStates
	emptyRecentTitle: 'Sie haben in letzter Zeit keine Inhalte angezeigt.',
	emptyStateTitle: 'Als ersten Schritt Daten hinzufügen',
	emptyStateBody: 'Auf die oben angezeigte Option zum Hochladen von Daten klicken oder Daten für den Upload hierher ziehen und ablegen. ',
	emptySearchResultTitle: 'Die Suche hat keine Ergebnisse geliefert. ',
	emptyPortalTitle: 'Keine Portale',
	emptyPortalBody: 'Sie verfügen derzeit nicht über Portale. ',
	emptyWsProjectTitle: 'Als ersten Schritt erstellen Sie ein Notebook in Watson Studio. ',
	emptyWsProjectBody: 'Wenn Sie Cognos Analytics erneut aufrufen, wird das Notebook hier angezeigt. ',
	emptyFilteredResultTitle: 'Die angewendeten Filter haben keine Ergebnisse geliefert. ',
	emptyDialogViewTitle: 'Keine Elemente',
	removeFromRecents: 'Aus zuletzt verwendeten Projekten entfernen',

	// Welcome Banner
	welcomeBannerGreeting: 'Hallo! Willkommen bei Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson unterstützt Benutzer mit AI-gesteuerter Self-Service-Analyse. Automatisierte Datenaufbereitung, Datenerkennung und Visualisierungen ermöglichen eine größere Entscheidungssicherheit.',
	welcomeBannerDescription_trialUser: 'Nutzen Sie zum Einstieg das Einführungsvideo, die Produkttour und die Informationen auf der Registerkarte \'Einführung\'. ',
	takeTourButtonLabel: 'Produkttour',
	watchVideoButtonLabel: 'Video ansehen',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Soll das Willkommensbanner auf der Startseite tatsächlich inaktiviert werden? Unter \'Profil und Einstellungen\' > \'Einstellungen\' > \'Allgemein\' kann diese Option zu jedem beliebigen Zeitpunkt erneut aktiviert werden. ',
	hideWelcomeBannerTitle: 'Willkommensbanner inaktivieren',
	ok: 'OK',
	cancel: 'Abbrechen',
	warn: 'Warnung',
	//howto video dialog
	modal_how_title: 'Cognos Analytics-Übersicht anzeigen',
	modal_overview_title: 'Cognos Analytics-Übersicht anzeigen',
	modal_how_play: 'Video abspielen',
	modal_how_video_title_overview: 'Übersicht',
	modal_how_video_title_getStarted: 'Einführung in 11.2',
	modal_how_video_title_newUI: 'Willkommen in der neuen Cognos-Umgebung',
	modal_how_video_title_dataModule: 'Datenmodule - Übersicht',
	modal_how_video_title_explore: 'Datenexplorationen - Übersicht',
	modal_how_video_title_dashboard: 'Interaktive Dashboards - Übersicht',
	modal_how_video_title_reporting: 'Berichterstellung - Übersicht',
	modal_how_video_title_mobile: 'Das Potenzial von Cognos in Ihrer Hand',

	// Toolbar
	search: 'Suchen',
	addFolder: 'Ordner hinzufügen',
	addLink: 'Link hinzufügen',
	filter: 'Filtern',
	sort: 'Sortieren',
	settings: 'Einstellungen',
	tilesView: 'Kachelansicht',
	listView: 'Listenansicht',
	columnView: 'Spaltenansicht',
	backToSearch: 'Zurück zu Suchergebnissen',

	// Toolbar Actions
	sortBy: 'Sortieren nach',
	sortOrder: 'Reihenfolge',
	name: 'Name',
	modifiedTime: 'Geändert',
	type: 'Typ',
	ascending: 'Aufsteigend',
	descending: 'Absteigend',
	resetSort: 'Sortierung zurücksetzen',

	filterType: 'Typ',
	filterModificationTime: 'Geändert',
	all: 'Alle',
	today: 'Heute',
	yesterday: 'Gestern',
	pastWeek: 'Letzte Woche',
	pastMonth: 'Letzten Monat',
	resetFilters: 'Filter zurücksetzen',
	resultLimit: 'Ergebnisgrenzwert',

	filterSearchPlaceHolder: 'Filtern nach Schlüsselwörtern',

	resetFilterTag: 'Zum Zurücksetzen der Filter auf X klicken.',
	filterTagToolTip: 'Angewendete Filter: %{appliedFilters}.',

	folderName: 'Ordnername',
	addAFolder: 'Ordner hinzufügen',
	add: 'Hinzufügen',
	error: 'Fehler',
	newFolderDefaultName: 'Neuer Ordner',
	toastCreateNewFolder: 'Der Ordner %{nameOfFolder} wurde in %{tabName} erstellt.',
	folderAdded: 'Ordner hinzugefügt',
	refresh: 'Aktualisieren',
	openFolder: 'Ordner öffnen',

	addAUrl: 'URL hinzufügen',
	linkName: 'URL-Name',
	linkNamePlaceholder: 'URL-Namen hinzufügen',
	linkDescription: 'Beschreibung (optional)',
	linkDescriptionPlaceholder: 'Beschreibung hinzufügen',
	linkUri: 'URL',
	linkUriPlaceholder: 'URL mit gültiger Domäne hinzufügen',
	acceptableDomains: 'Gültige Domänen',
	viewAcceptableDomains: 'Gültige Domänen anzeigen',
	mandatoryField: 'Obligatorisches Feld',
	linkAdded: 'URL hinzugefügt',
	toastCreateNewLink: '%{nameOfLink} wurde zu %{tabName} hinzugefügt.',
	noEntries: 'Diese Liste gültiger Domänen enthält keine Einträge. Wenden Sie sich an den Administrator.',
	unacceptableDomain: 'Die URL verwendet eine ungültige Domäne. Klicken Sie auf \'Gültige Domänen anzeigen\', um eine Liste mit Domänen aufzurufen, die Sie verwenden können.',

	compact: 'Kompakt',
	short: 'Kurz',
	default: 'Standard',
	rowSize: 'Zeilenlänge',

	// GroupyByTypes
	folders: 'Ordner',
	reports: 'Berichte',
	dashboards: 'Dashboards',
	data: 'Daten',
	packages: 'Packages',
	explorations: 'Explorationen',
	stories: 'Storys',
	notebooks: 'Notebooks',
	others: 'Sonstige',

	// Error Messages
	itemsOverLimit: 'Der angegebene Name "%{itemName}" hat den maximalen Grenzwert (20) überschritten. Geben Sie einen anderen Namen an, um die Aktion fortzusetzen.',
	errorMessageLengthFolderName: 'Geben Sie einen Ordnernamen ein, der nicht länger als 255 Zeichen ist.',
	errorMessageLengthLinkName: 'Geben Sie einen Linknamen ein, der nicht länger als 255 Zeichen ist.',
	toastLaunchPerspectiveError: 'Öffnen von %{objectType} nicht möglich.',
	errorNoAccessTitle: 'Sie verfügen nicht über die Zugriffsberechtigung für diesen Inhalt.',
	errorNoAccessBody: 'Wenden Sie sich an den zuständigen Administrator oder rufen Sie weitere Informationen über den folgenden Link auf:',
	errorEnableExternalContent: 'Externen Inhalt aktivieren',

	//TableHeader
	lastAccessed: 'Letzter Zugriff',
	location: 'Position',
	tenant: 'Tenant',

	// GetStartedTab
	getStartedLabel: 'Einstieg in IBM Cognos Analytics',
	learningHowToLabel: 'Lernressourcen',
	learningHowToDescription: 'Sie können Informationen mit der Community austauschen, die Dokumentation lesen und Videos ansehen, um Ihre Kenntnisse zu erweitern und Unterstützung zu erhalten. ',
	learningHowToActionLabel: 'Fenster mit Lernressourcen öffnen',
	howToVideosLabel: 'Videos zur Vorgehensweise',
	howToVideosDescription: 'Hier können Sie sich mit der Verwendung von IBM Cognos Analytics vertraut machen und Insights zu Ihren Daten sammeln. ',
	howToVideosActionLabel: 'Videos ansehen',
	acceleratorCatalogLabel: 'Accelerator Catalog',
	acceleratorCatalogDescription: 'In diesem ständig erweiterten Katalog finden Sie branchenspezifische Anwendungsmöglichkeiten, Beschreibungen bewährter Verfahren, angepasste Visualisierungen und mehr. ',
	acceleratorCatalogActionLabel: 'Katalog durchsuchen',
	sampleSectionTitle: 'Beispiele',
	sampleSectionDescription: 'Sie können mit Beispielen experimentieren, die die Möglichkeiten von Cognos Analytics veranschaulichen. ',
	// Samples Section
	createDashboardSampleTitle: 'Vorgehensweise zur Erstellung des ersten Dashboards',
	createDashboardSampleDescription: 'Cognos-Dashboards bieten einen Einstieg in die Datenanalyse. ',
	nlaSampleTitle: 'Beispielbericht',
	nlaSampleDescription: 'Erkunden Sie, was mit Cognos Analytics-Berichten möglich ist. In diesem Beispiel wird zum Jahresende die Aktivität von Treuekartenmitgliedern analysiert.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Sie können Ihre Visualisierungsbibliothek mit angepassten Visualisierungen, wie z. B.dem Sankey-Diagramm, erweitern. ',
	viewAllSamplesActionLabel: 'Alle Beispiele anzeigen',
	byFeatureTitle: 'Nach Feature',
	byFeatureDescription: 'Beispiele anhand von Features durchsuchen, z. B. zentrale Funktionen, benutzerdefinierte Steuerelemente, Erweiterungen, Notebooks und relative Datumsangaben. ',
	byIndustryTitle: 'Nach Branche',
	byIndustryDescription: 'Beispiele anhand der Branche durchsuchen, z. B. Automobilbranche, Finanzbranche usw. ',
	// SamplesTab
	sampleTabTitle: 'Lassen Sie sich von den vordefinierten Beispielen inspirieren! ',
	sampleTabLabel: 'Im Accelerator Catalog finden Sie weitere Beispiele und Erweiterungen von IBM, Partnern und Kunden.',

	// quickLaunch
	quickLaunchLabel: 'Schnellstart',
	expand: 'Einblenden',
	collapse: 'Ausblenden',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Wählen Sie als ersten Schritt aus, was erstellt werden soll. ',

	// contentPageView
	contentPageTitleLabel: 'Inhalt',
	uploadFile: 'Daten hochladen',
	new: 'Neu',
	create: 'Erstellen',
	more: 'Mehr',

	// open dialog
	selectDataSourcesToAdd: 'Datenquelle(n) zum Hinzufügen auswählen. ',
	openDialogDefaultTitle: 'Öffnen',

	// save dialog
	save: 'Speichern',
	saveAs: 'Speichern unter',
	saving: 'Speichern wird ausgeführt...',
	selectedDestination: 'Ausgewähltes Ziel: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' ist bereits mit einem anderen Typ vorhanden. Wählen Sie einen anderen Namen aus.',
	confirmOverwriteTitle: 'Ersetzen vorhandener Daten bestätigen',
	confirmOverwriteMsg: 'Die Datei \'%{nameOfFile}\' ist bereits vorhanden. Sollen die Daten dieser Datei mit den Daten der ausgewählten Datei ersetzt werden?',

	// copy move dialog
	copy: 'Kopieren',
	move: 'Verschieben',
	copyOrMove: 'Kopieren oder verschieben: ',
	copyOnly: 'Kopieren ',
	createShortcut: 'Verknüpfung erstellen',
	createShortcutDialogTitle: 'Verknüpfung erstellen: ',

	// External asset types
	wsProject: 'Watson Studio-Projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Package',
	dataModule: 'Datenmodul',
	exploration: 'Exploration',
	mode: 'Modus',
	live: 'Dynamisch',
	snapshot: 'Momentaufnahme',
	noSnapshotsFound: 'Keine Momentaufnahmen gefunden',
	uploadedFile: 'Hochgeladene Datei',
	fileUpload: 'Daten hochladen',
	dataSetEx: 'Dataset',
	externalRepository: 'Externes Repository',
	queryMode: 'Abfragemodus',
	queryModeCompatible: 'Kompatibel',
	queryModeDynamic: 'Dynamisch',
	report: 'Bericht',
	activeReport: 'Aktiver Bericht',
	query: 'Abfrage',
	analysis: 'Analyse',
	dashboard: 'Dashboard',
	dashboardTemplate: 'Dashboardvorlage',
	jupyterNotebook: 'Notebook',
	wsNotebook: 'Watson Studio-Notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Story',
	workspace: 'Arbeitsbereich',
	pagelet: 'Seite',
	content: 'Inhalt',
	directory: 'Namespaces',
	dataSet: 'Dataset',
	powerPlayCube: 'PowerPlay-Cube',
	powerPlayReport: 'PowerPlay-Bericht',
	powerPlay8Report: 'PowerPlay-Bericht',
	setPowerPlay8ReportOptions: 'PowerPlay-Berichtsoptionen festlegen',
	powerPlay8ReportView: 'PowerPlay-Berichtsansicht',
	reportTemplate: 'Berichtsvorlage',
	packageConfigurations: 'Packagekonfiguration',
	agent: 'Agent',
	agentDefinition: 'Agentendefinition',
	agentDefinitionView: 'Agentenansicht',
	dataMovementTask: 'Aufgabe zum Verschieben von Daten',
	dataMovementTaskAlias: 'Aufgabenalias zum Verschieben von Daten',
	document: 'Dokument',
	DocumentRetention: 'Dokumenteigenschaften',
	jobDefinition: 'Jobdefinition',
	job: 'Job',
	jobs: 'Jobs',
	metricsDataSourceETLTask: 'Aufgabe für Metrikdatenquellen-ETL',
	metricsExportTask: 'Aufgabe zum Exportieren von Metriken',
	metricsFileImportTask: 'Aufgabe zum Importieren von Metrikdateien',
	metricsMaintenanceTask: 'Aufgabe zum Verwalten von Metriken',
	planningTask: 'Planungsaufgabe',
	shortcut: 'Verknüpfung',
	shortcuts: 'Verknüpfungen',
	URL: 'URL',
	launchable: 'Startfähig',
	dataSetFolder: 'Ordner für Dataset',
	ViewAccessibleLabel: '%{label} anzeigen',
	overrideReportOptions: 'Standardberichtsoptionen überschreiben',
	formats: 'Formate',
	saveReport: 'Bericht speichern',
	reportView: 'Berichtsansicht',
	reportviews: 'Berichtsansichten',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-Daten',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rolle',
	namespace: 'Namensbereich',
	namespaceFolder: 'Namensbereichsordner',
	adminFolder: 'Administratorordner',
	//Details
	details: 'Details',
	open: 'Öffnen',
	created: 'Erstellt',
	modified: 'Geändert',
	owner: 'Eigentümer',
	dataSource: 'Datenquelle',
	share: 'Teilen',
	addToFavorites: 'Zu Favoriten hinzufügen',
	properties: 'Eigenschaften',
	detailsEmptyStateBody: 'Element auswählen, um die zugehörigen Details anzuzeigen',
	editNameAndDescription: 'Namen und Beschreibung bearbeiten',
	none: 'Ohne',
	setPdfOptions: 'PDF-Optionen festlegen',
	runOptions: 'Ausführungsoptionen',

	//rename dialog
	nameInvalid: 'Name ist nicht gültig',
	namePlaceholder: 'Namen eingeben',
	description: 'Beschreibung',
	descriptionInvalid: 'Die Beschreibung darf nicht mehr als 350 Zeichen enthalten. ',
	descriptionPlaceholder: 'Beschreibung eingeben',
	errorMessageApostropheError: 'Geben Sie einen Dateinamen ein, der nicht gleichzeitig die Zeichen \' und " enthält.',
	renameCollisionError: '%{name} ist bereits vorhanden. Verwenden Sie einen anderen Namen. ',
	unknownRenameError: 'Umbenennen des Elements fehlgeschlagen. Weitere Unterstützung erhalten Sie beim Administrator. ',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Öffnen des angegebenen Ordners nicht möglich.',

	//Upload
	uploadToFolder: "In <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction} hochladen",
	uploadAndLaunch: "In <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> hochladen und %{launchAction} starten",
	quickUpload: "Schneller Upload",
	quickUploadAndLaunch: "Dateien für den Upload in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> hierher ziehen und ablegen und in einem der folgenden Bereiche öffnen. ",
	unsupportedFilesSingle: "Upload von %{files} nicht ausgeführt, da dies für den Schnellstart nicht zulässig ist.",
	unsupportedFilesMultiple: "Die Dateien wurden nicht hochgeladen, da alle ausgewählten Dateien für die Verwendung des Schnellstarts zulässig sein müssen.",
	unsupportedFilesSingleInvalid: "%{files} ist nicht gültig.",
	unsupportedFilesMultipleInvalid: "%{files} sind nicht gültig.",
	supportedFileTypes: "Nur die folgenden Dateitypen sind zulässig: %{extensions}.",
	uploadDragAndDrop: "Ziehen und ablegen",
	uploadDragAndDropMessage: "Datei für den Upload in <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> hierher ziehen und ablegen",

	// searchBar
	searchWasSaved: 'Suchkriterien \'%{searchTerm}\' wurden gespeichert. ',
	searchWasntSaved: 'Suchkriterien \'%{searchTerm}\' wurden nicht gespeichert. ',
	searchSuggestions: 'Vorschläge',
	savedSearch: 'Gespeicherte Suchen',
	searchWasDeleted: 'Suchkriterien \'%{searchTerm}\' wurden gelöscht. ',
	searchWasntDeleted: 'Suchkriterien \'%{searchTerm}\' wurden nicht gelöscht. ',
	savedBarTitle: 'Cognos Analytics durchsuchen',
	searchContentPageTitle: 'Suchen',
	searchContentPageTitleLabel: 'Ergebnisse für \'%{searchTerm}\' werden angezeigt',
	showingSearchRsult: '%{resultCount} Elemente werden angezeigt',
	saveSearch: 'Suche speichern',
	saveTenSearches: 'Sie können 10 Suchen speichern.',
	deleteASearch: 'Eine Suche löschen, um eine andere zu speichern.',
	close: 'Schließen',
	allContent: 'Gesamter Inhalt',
	searchResultIn: 'Suchergebnisse in: ',
	//recent view
	recents: 'Kürzlich aufgerufener Inhalt',
	noAccessRecent: 'Kein Zugriff',
	noAccessRecentMsg: 'Sie verfügen nicht über Zugriff auf dieses Asset. Es wurde möglicherweise inaktiviert oder gelöscht oder Ihre Berechtigungen wurden eingeschränkt. Verifizieren Sie den Status des Assets an der erwarteten Quellenposition. Sie können das Asset aus den kürzlich verwendeten Elementen entfernen, indem Sie auf OK klicken.',
	noAccessMsg: 'Sie verfügen nicht über Zugriff auf dieses Asset. Es wurde möglicherweise inaktiviert oder gelöscht oder Ihre Berechtigungen wurden eingeschränkt.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} Elemente ausgewählt',
	itemSelected: '%{nameOfSelection} Element ausgewählt',

	//properties
	general: 'Allgemein',
	schedule: 'Planen',
	permission: 'Berechtigungen',
	capabilities: 'Leistungsspektrum',
	propertiesTabsLabel: 'Inhalte für Eigenschaften',
	searchPath: 'Suchpfad',
	id: 'ID',
	language: 'Sprache',
	setLanguage: 'Sprache festlegen',
	entryOptions: 'Eingabeoptionen',
	setPackage: 'Paket oder Modul festlegen',
	sourcePackage: 'Quellenpackage oder Datenmodul',
	associatedSourceAgent: 'Quellenpackage',
	setAssociatedSourceAgent: 'Paket festlegen',
	sourceAgent: 'Quellenagent',
	setSourceAgent: 'Quellenagenten festlegen',
	setCapabilities: 'Leistungsspektrum festlegen',
	disableEntry: 'Diesen Eintrag inaktivieren',
	hideEntry: 'Diesen Eintrag ausblenden',
	permissions: 'Berechtigungen',
	promptForValues: 'Zur Eingabe von Werten auffordern',
	yes: 'Ja',
	no: 'Nein',
	setValues: 'Werte festlegen',
	moreOptions: 'Weitere Optionen',
	reportFormat: 'Berichtsformat',
	enableAccessibilitySupport: 'Unterstützung von Eingabehilfen aktivieren',
	displayOfRunHistory: 'Anzeige des Ausführungsverlaufs',
	occurrences: 'Auftreten',
	days: 'Tag(e)',
	months: 'Monat(e)',
	displayOfReportOutputVersions: 'Anzeige der Berichtsausgabeversion',
	defaultDisplayOfPortalAction: 'Standardportalaktion',
	viewMostRecentReport: 'Aktuellsten Bericht anzeigen',
	runTheReport: 'Bericht ausführen',
	openWithReportStudio: 'Mit Report Studio öffnen',
	rowsPerPageInHtmlReports: 'Zeilen pro Seite in HTML-Berichten',
	enableSelectionBasedInteractivity: 'Auswahlbasierte Interaktivität aktivieren',
	enableAlertsAboutNewVersions: 'Alerts zu neuen Versionen aktivieren',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Erweiterte Benutzerfunktionen in gespeicherte Ausgabeversionen aktivieren',
	enableCommentsInSavedOutputVersions: 'Kommentare in gespeicherten Ausgabeversionen aktivieren',
	run: 'Ausführen',
	runWithUsersCredentials: 'Mit den Berechtigungsnachweisen des Benutzers',
	runWithOwnerCapabilities: 'Mit Eignerfunktion',
	runAsOwner: 'Als %{ownerName}',
	actionLabelOn: 'Ein',
	actionLabelOff: 'Aus',
	openReport: 'Bearbeiten',
	openAnalysis: 'Mit Analysis Studio öffnen',
	openQuery: 'Mit Query Studio öffnen',
	openPowerPlay8Report: 'Mit PowerPlay Studio öffnen',
	openInteractiveReport: 'Bearbeiten',
	read: 'Gelesen',
	write: 'Schreiben',
	execute: 'Execute',
	setPolicy: 'Richtlinie festlegen',
	full: 'Voll',
	traverse: 'Transit',
	grant: 'Erteilen',
	deny: 'Ablehnen',
	permissionCustom: 'Benutzerdefiniert',
	permissionDetailsColumnAccess: 'Zugriff',
	permissionDetailsColumnPermission: 'Berechtigung',
	permissionDetailsColumnAction: 'Aktion',
	permissionSetAccess: 'Gruppenzugriff',
	permissionRead: 'Gelesen',
	permissionRun: 'Ausführen',
	permissionWrite: 'Schreiben',
	permissionFull: 'Voll',
	unavailable: 'Nicht verfügbar',
	unkownSource: 'Unbekannt; für Details den Bericht öffnen',
	tenantSettings: 'Tenanteinstellungen',
	tenantSet: 'Tenant aktualisiert',
	tenantSetError: 'Fehler beim Festlegen des Tenants',
	tenantClear: 'Tenant gelöscht',
	tenantClearError: 'Fehler beim Löschen des Tenants',
	shortcutTo: 'Verknüpfung mit',
	sourceReport: 'Quellenbericht',
	setSourceReport: 'Quellenbericht festlegen',
	setSourceLocation: 'Quelle %{itemName} Position festlegen',
	linkPackageOrModule: '%{itemName} mit einem Package oder Datenmodul verlinken',
	linkPackage: '%{itemName} mit einem Paket verknüpfen',
	externalRepositories: 'Externe Repositorys',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Aktualisierungszeit',
	size: 'Größe',
	tenantsWarningMessage: 'Durch das Ändern des Tenants für einen Eintrag wird auch den Tenant für die untergeordneten Einträge geändert.',
	confirmClearTenantText: 'Wenn der Wert in \'Keine\' geändert wird, können andere Tenants möglicherweise auf den Inhalt zugreifen. Klicken Sie auf OK, um den Eintrag öffentlich zu machen, oder klicken Sie auf \'Abbrechen\', um den aktuellen Tenant beizubehalten.',
	confirmClearTenant: 'Löschen des Tenants bestätigen',
	currentValues: 'Aktuelle Werte',
	emptyPromptValues: 'Momentan sind keine Werte vorhanden',
	editValues: 'Werte bearbeiten',
	clear: 'Löschen',
	source: 'Quelle',
	dataRefreshed: 'Daten aktualisiert',
	//PDF options
	pdfOptions: 'PDF-Optionen',
	set: 'Festlegen',
	portrait: 'Hochformat',
	landscape: 'Querformat',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Ausrichtung',
	pageDefination: 'Papierformat',
	openPasswordRequired: 'Kennwort zum Öffnen des Berichts erforderlich',
	accessPasswordRequired: 'Kennwort für Zugriff auf Bericht erforderlich',
	emptyPassword: 'Kennwort darf nicht leer sein',
	password: 'Kennwort',
	enterPassword: 'Kennwort eingeben',
	confirmPassword: 'Kennwort bestätigen',
	passwordMatchError: 'Die Kennwörter stimmen nicht überein.',
	gateway: 'Gateway',
	pageLayout: 'Seitenlayout',
	pageStyle: 'Stil',
	setUrl: 'URL festlegen',
	numberRows: 'Anzahl der Zeilen',
	numberColumns: 'Anzahl der Spalten',
	timeToRefresh: 'Aktualisierungszeit',
	lastRefreshedBy: 'Aktualisiert von',
	unknown: 'Unbekannt',
	unknownUpdateError: 'Aktualisieren des Elements fehlgeschlagen. Weitere Unterstützung erhalten Sie beim Administrator.',
	editQuery: 'Abfrage bearbeiten',
	greaterOrEqual: 'Größer-gleich %{upperboundValue}',
	lessOrEqual: 'Kleiner-gleich %{lowerboundValue}'
});
